<template>
   <v-layout aling-start>
      <v-flex>
         <v-container fluid>
            <v-layout
               wrap
               :style="
                  $vuetify.breakpoint.xlOnly
                     ? 'padding-right: 10%; padding-left: 10%'
                     : ''
               "
            >
               <!-- TÍTULO -->
               <v-flex xs12 text-center mb-8>
                  <span class="font-weight-medium text-h5">Pagos</span>
                  <div class="caption grey--text text--darken-1 mt-2">
                     Seleccione el apartado que desea consultar.
                  </div>
               </v-flex>

               <!-- OPCIONES -->
               <v-flex xs12>
                  <v-container class="px-1" grid-list-md fluid>
                     <v-layout wrap justify-center>
                        <v-flex
                           v-for="opcion in opcionesVisibles"
                           :key="opcion.ruta"
                           xs12
                           sm6
                           md4
                        >
                           <v-layout align-center justify-center wrap>
                              <!-- BOTON -->
                              <v-flex
                                 xs12
                                 :class="
                                    $vuetify.breakpoint.smAndUp ? 'px-8' : ''
                                 "
                              >
                                 <v-btn
                                    rounded
                                    color="primary"
                                    block
                                    height="60px"
                                    x-large
                                    @click="ir(opcion.ruta)"
                                 >
                                    <v-icon left>{{ opcion.icono }}</v-icon>
                                    {{ opcion.titulo }}
                                 </v-btn>
                              </v-flex>

                              <!-- DESCRIPCION -->
                              <v-flex xs12 class="text-center mt-4 mb-8">
                                 <div
                                    class="body-2 grey--text text--darken-1"
                                    style="white-space: pre-wrap"
                                 >
                                    {{ opcion.descripcion }}
                                 </div>
                              </v-flex>
                           </v-layout>
                        </v-flex>
                     </v-layout>
                  </v-container>
               </v-flex>
            </v-layout>
         </v-container>
      </v-flex>
   </v-layout>
</template>

<script>
import { authComputed } from '../helpers'

// Cada apartado con el permiso que lo habilita. Son los mismos permisos que
// antes gobernaban los ítems sueltos del menú lateral.
const OPCIONES = [
   {
      permiso: 8,
      ruta: 'pagosIdiomas',
      titulo: 'Idiomas',
      icono: 'fas fa-comments-dollar',
      descripcion: 'Pagos de módulos de inglés y francés.'
   },
   {
      permiso: 7,
      ruta: 'pagosLibreria',
      titulo: 'Librería',
      icono: 'fas fa-book',
      descripcion: 'Pagos realizados en librería.'
   },
   {
      permiso: 2,
      ruta: 'pagos',
      titulo: 'Contabilidad',
      icono: 'fas fa-money-check-alt',
      descripcion: 'Pagos registrados por contabilidad.'
   },
   {
      permiso: 21,
      ruta: 'historialDePagos',
      titulo: 'Anulación de pagos',
      icono: 'fas fa-history',
      descripcion: 'Historial de pagos y anulación de los ya registrados.'
   }
]

export default {
   name: 'PagosMenu',
   computed: {
      ...authComputed,
      // Solo los apartados que el usuario tiene permitidos.
      opcionesVisibles() {
         return OPCIONES.filter((o) => this.puede(o.permiso))
      }
   },
   created() {
      // Sin ningún permiso de pagos no hay nada que mostrar.
      if (!this.opcionesVisibles.length) {
         this.$router.push({ name: 'inicio' })
      }
   },
   methods: {
      /**
       * permController lanza TypeError si el usuario no tiene fila para ese
       * controlador, y acá eso tumbaría la pantalla; se degrada a "sin acceso".
       */
      puede(permiso) {
         try {
            return this.permController(permiso, 'ver')
         } catch (e) {
            return false
         }
      },
      ir(ruta) {
         this.$router.push({ name: ruta })
      }
   }
}
</script>

<style scoped>
.colorPrimary {
   color: var(--v-primary-base) !important;
}
</style>
